import { Metamodel } from 'app/model/base/model';
import { FileTypeCopySource } from './file-type.copysource';
import { FileShareDataset } from 'app/model/dataset/file-share.dataset';
import { AmazonS3Dataset } from 'app/model/dataset/amazon-s3.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.fileSystem.copySourceType,
    display: [],
    tags: { datasetModel : [Metamodel.modelFor(FileShareDataset), Metamodel.modelFor(AmazonS3Dataset)]}
})
export class FileSystemCopySource extends FileTypeCopySource {
}
